export enum DelayType {
  Interval = 'Interval',
  Date = 'Date',
  Property = 'Property'
}

export class DelayDataLimitType {
  from!: string
  to!: string
  days_of_week!: Array<number>
}
